import { combineReducers } from "redux";
import activeMentors from "./activeMentorReducer";
import apiCallsInProgress from "../../../Shared/Redux/Reducers/apiStatusReducer";
import assignedMentors from "./assignedMentorReducer";
import completedMentors from "./completedMentorReducer";
import localizations from "./localizationsReducer";
import mentorAccess from "../../../Shared/Redux/Reducers/mentorAccessReducer";
import queuedMentors from "./queuedMentorReducer";
import sessionToActivate from "./sessionToActivateReducer";
import upcomingMentors from "./upcomingMentorReducer";
import waitingForSignOff from "./waitingForSignOffReducer";
import userInfo from "./userInfoReducer";
import apiError from "../../../Shared/Redux/Reducers/apiErrorReducer";

const rootReducer = combineReducers({
    localizations,
    activeMentors,
    queuedMentors,
    completedMentors,
    upcomingMentors,
    apiCallsInProgress,
    assignedMentors,
    sessionToActivate,
    mentorAccess,
    userInfo,
    waitingForSignOff,
    apiError,
});

export default rootReducer;
